import React from 'react';

interface Props {
  className?: string;
  exchange: string;
  otcTier?: string | null;
  symbol: string;
}

const ExchangeSymbol: React.FC<Props> = ({ className = '', exchange, otcTier, symbol }) => {
  let otcExchangeTicker: string | null = null;
  if (exchange === 'OTC') {
    otcExchangeTicker = exchange + otcTier;
  }

  const exchangeBlock = exchange === 'OTC' ? otcExchangeTicker : exchange;

  return (
    <span className={`quote-exchange-information ${className}`}>
      ({exchange ? `${exchangeBlock}:` : ''}
      {symbol})
    </span>
  );
};

export default ExchangeSymbol;
